import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { Button } from '../../../components/Button/Button'

export interface RerunEmailResponseModalProps {
  show: boolean
  onConfirm: () => void
  onHide: () => void
}

export const RerunEmailResponseModal: React.FC<RerunEmailResponseModalProps> = ({ show, onConfirm, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={
        <div className='d-flex flex-column zocks-gap-3'>
          <h4 className='text-center'>
            The email type has been changed. Do you want to generate a new reply? All your previous manual edits will be lost, if you generate a new AI reply.
          </h4>
        </div>
      }
      footer={
        <div className='d-flex flex-grow-1 gap-3 align-items-center'>
          <Button variant='secondary' className='flex-grow-1' onClick={onHide}>
            Keep Current
          </Button>
          <Button variant='primary' className='flex-grow-1' onClick={onConfirm}>
            Generate New
          </Button>
        </div>
      }
      centered={true}
    />
  )
}
